module.exports = __webpack_public_path__ + "img/union-2.1228dc72.svg";